import { SelectOption } from "@/types/select";

export const ALL_PARTICIPANTS_OPTION: SelectOption = {
  value: "all",
  label: "All Program Participants",
};
